import sectionTabs from './section-tabs.js'

(($) => {
    $.fn.sectionTabs = sectionTabs

    //if the tab section exists and there is a tab list
    if( $('.tabbed-section').length > 0 && $('.button-tabs').length > 0 ){
        $('.tabbed-section').sectionTabs();
    }

})(jQuery)


/**
 * Author: Ryan Hendrickson
 * Date: January 2024
 * Description: Used on /help-center to filter search results on page
 */

// grab elements
const noSearchResults = document.getElementById('no-search-results');
const searchForm = document.getElementById('help-center-search-form');
const searchBox = document.getElementById('help-center-search-keyword');
const searchButton = document.getElementById('help-center-search-submit');
const searchClear = document.getElementById('help-center-search-clear');
const searchSite = document.getElementById('search-site');

// assign event listeners
searchForm.addEventListener('submit', (event) => {
    event.preventDefault();
    searchForText();
});

searchClear.addEventListener('click', () => {
    clearSearch();
    searchBox.value = '';
});

/**
 * Hides faq-topic-groupss, panel-headlines, and panel-contents depending on user search.
 * If the search returns no results then we display a helpful little message.
 */
function searchForText() {
    clearSearch();
    const searchContent = searchBox.value.toLowerCase();
    let countOfTotalElems = 0;
    let countOfHiddenElems = 0;

    // the amount of elements with panel-headline as a class and panel-content should always be equal
    // if neither of the headline or content contain the text we're searching for then we should hide both.
    const panelHeadlines = document.querySelectorAll('.panel-headline');
    for (const panelHeadline of panelHeadlines) {
        if (!panelHeadline.innerText.toLowerCase().includes(searchContent) &&
            !panelHeadline.nextElementSibling.innerText.toLowerCase().includes(searchContent)) {
            panelHeadline.classList.add('hidden-faq');
            panelHeadline.nextElementSibling.classList.add('hidden-faq');
            // 2 elems, 1 headline and 1 body
            countOfHiddenElems += 2;
        }
        // 2 elems, 1 headline and 1 body
        countOfTotalElems += 2;
    }

    // cycle over the faq-topic-groupss and grab all their children with a class of panel-headline
    // if any of those panel-headlines aren't hidden, then we don't hide the faq-topic-groups
    const faqSections = document.querySelectorAll('.faq-topic-group');
    for (const patternHeadline of faqSections) {
        let hide = true;
        const panelHeadlines = patternHeadline.querySelectorAll('.panel-headline');
        for (const panelHeadline of panelHeadlines) {
            if (!panelHeadline.classList.contains('hidden-faq')) {
                hide = false;
                break;
            }
        }
        if (hide) {
            patternHeadline.classList.add('hidden-faq');
            countOfHiddenElems++;
        }
        countOfTotalElems++;
    }

    if (countOfTotalElems === countOfHiddenElems) {
        searchSite.href = `/search/?sitka_search=${searchContent}`;
        noSearchResults.classList.remove('hidden');
    }
}

/**
 * Un-hides everything that was hidden during searching.
 * Hide helpful message.
 */
function clearSearch() {
    const elements = document.querySelectorAll('.hidden-faq');

    noSearchResults.classList.add('hidden');

    for (const element of elements) {
        element.classList.remove('hidden-faq');
    }
}